import api from '..';
import { CITY } from './types';
import { useEffect, useState } from 'react';

export const useCities = (uf: string) => {
  const [cities, setCities] = useState<CITY[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    api
      .get(`/core/ufs/${uf}/cities`)
      .then(({ data }) => setCities(data))
      .finally(() => setIsLoading(false));
  }, [uf]);

  return { cities, isLoading };
};
